var React = require('react');

function FieldEmail (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"className":"stroke","transform":"translate(-718.000000, -2503.000000)","stroke":"#231F20","strokeWidth":"1.5"},React.createElement("g",{"transform":"translate(720.000000, 2224.000000)"},React.createElement("g",{"transform":"translate(0.000000, 147.000000)"},React.createElement("g",{"transform":"translate(0.000000, 99.000000)"},React.createElement("g",{"transform":"translate(0.000000, 34.000000)"},React.createElement("polygon",{"fill":"#FFFFFF","points":"25.1184387 49.1398926 0 0.427246094 541 0.427246094 514.214481 21 535.642896 21 514.214481 49.1398926"}))))))));
}

FieldEmail.defaultProps = {"preserveAspectRatio":"none","width":"546px","height":"51px","viewBox":"0 0 546 51","version":"1.1"};

module.exports = FieldEmail;

FieldEmail.default = FieldEmail;
